import React, { FC } from 'react'
import { IframeComponent, FormBlockComponent } from 'LibNeo'
// eslint-disable-next-line max-len
import { SuccessMessageForModalComponent } from 'Pages/orders_design/components/desktop_orders/modals/SuccessMessageForModal'

export interface ComponentProps {
	url: string
	orderId: number
}

export const IframeModalComponent: FC<ComponentProps> = ({ url, orderId }) => {
	return (
		<>
			<FormBlockComponent>
				<SuccessMessageForModalComponent
					orderId={orderId}
					subTitle="Обязательно предоставьте дополнительные сведения для подключения продукта!"
				/>
			</FormBlockComponent>
			<IframeComponent url={url} indent={300} />
		</>
	)
}
